<div class="block-page-title">
    <h2 class="page-title">
        {{auth.user.rusrole}} 
        
        <span *ngIf="auth.user.group">группы  «{{auth.user.group}}»</span> 

    </h2>
</div>

<a *ngIf="auth.roleMatch(['creator','superadmin'])" [routerLink]="['/admin/courses']">Мои курсы</a>
<a *ngIf="auth.roleMatch(['creator','superadmin'])" [routerLink]="['/mypolls']" href="">Опросники</a>
<a *ngIf="auth.roleMatch(['admin','superadmin'])" [routerLink]="['/admin/gusers']" href="">Студенты</a>
<a *ngIf="auth.roleMatch(['superadmin'])" [routerLink]="['/admin/groups']" href="">Группы</a>
<router-outlet></router-outlet>
